export default {
  currentTool: null,
  query: null,
  lastQuery: null
}
